import React, { useCallback, useEffect, useMemo } from 'react';
import ReactEcharts from 'echarts-for-react/lib/core';
import useDataApi from '../../hooks/useDataApi';
import constantes from '../../resources/constantes.json';
import {
  registerMap,
  init,
  dispose,
  getInstanceByDom,
} from 'echarts/src/echarts';
import usePrevious from '../../hooks/usePrevious';
import 'echarts/src/chart/map';
// import 'echarts/src/component/visualMap';
import 'echarts/src/component/tooltip';
import 'echarts/src/component/markPoint';
import { useMap } from '../../contexts/mapContext';
import { getUrl } from '../../utils';
import { useParentLevel } from '../../contexts/pageContext';
import TooltipMapa from '../../components/TooltipMapa';

const mapRegisterOptions = {
  '56': {
    top: 90,
    left: -800,
    width: 20,
  },
};

const scaleGeoJson = data => {
  const scaleFactor = data.scaleFactor || 30;
  const scale = num => num * scaleFactor;
  const loopArray = arr => {
    if (Array.isArray(arr[0]) || typeof arr[0] !== 'number')
      return arr.map(loopArray);
    return arr.map(scale);
  };
  data.features = data.features.map(feature => {
    feature.geometry.coordinates = loopArray(feature.geometry.coordinates);
    return feature;
  });
  return data;
};

const echarts = {
  init,
  dispose,
  getInstanceByDom,
};
const mapName = (citrep, name) => {
  const path = citrep ? constantes.rutas.mapasCitrep : constantes.rutas.mapas;
  return path + name + '.geojson';
};
const Mapa = props => {
  const [mapaData, setMapaData] = useDataApi(
    {
      initialUrl: mapName(props.citrep, props.name),
      cache: true,
    },
    scaleGeoJson
  );
  if(mapaData.data){
    registerMap(props.name, mapaData.data, mapRegisterOptions);
  }
  const prevName = usePrevious(mapaData.data ? mapaData.data.name : undefined);
  const prevData = usePrevious(props.getOption._id);
  const { mapRef, setTooltipVisible } = useMap();
  const parentLevel = useParentLevel();

  function suppressSelection(chart, params) {
    chart.setOption({ animation: false });

    // Re-select what the user unselected
    chart.dispatchAction({
      type: 'datarangeselected',
      name: params.name,
    });

    chart.setOption({ animation: true });
  }
  const {
    history,
    nomenclator,
    eleccion,
    esHistorico,
    page,
  } = props.eventsProps;

  const onEvents = useMemo(
    () => ({
      click: params => {
        if (params.data && !esHistorico) {
          const hayEleccion = nomenclator.ambitos[eleccion].some(
            e => e.c === params.name
          );
          if (!hayEleccion) return;
          const ambito = nomenclator.ambitos[eleccion].find(
            e => e.c === params.name
          );
          history.push(
            getUrl({
              id: ambito.i,
              eleccion,
              nomenclator,
              page,
              parentLevel,
            })
          );
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
          });
        }
      },
      mousemove: params => {
        setTooltipVisible(true);
        if (params.data) {
          const hayEleccion = nomenclator.ambitos[eleccion].some(
            e => e.c === params.name
          );
          hayEleccion
            ? (params.event.event.target.style.cursor = 'pointer')
            : (params.event.event.target.style.cursor = 'default');
        }
      },
      mouseout: params => {
        params.event.event.target.style.cursor = 'default';
        setTooltipVisible(false);
      },
      globalout: eventData => {
        setTooltipVisible(false);
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const setMapOptions = useCallback(
    option => {
      const map = mapRef.current;
      if (map) {
        // eslint-disable-next-line no-unused-expressions
        map.getEchartsInstance()?.setOption?.(option);
      }
    },
    [mapRef]
  );

  useEffect(() => {
    const map = mapRef.current;
    if (mapaData.data) {
      registerMap(props.name, mapaData.data, mapRegisterOptions);
      setMapaData(mapName(props.citrep, props.name));
      if (!prevName || prevName !== mapaData.data.name) {
        props.setMapFeatures(mapaData.data);
        setMapOptions(props.getOption);
      }
      if (!prevData || prevData !== props.getOption._id) {
        setMapOptions(props.getOption);
      }
      const mychart = map.getEchartsInstance();

      mychart.on('datarangeselected', function(params) {
        suppressSelection(map.getEchartsInstance(), params);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapaData.data, prevName, props.getOption, props.name]);

  const getOption = () => {
    const option = {
      series: {
        itemStyle: {
          borderColor: '#fff',
          shadowBlur: 0,
          emphasis: {
            areaColor: '#fff',
            borderColor: '#ffffff00',
            label: {
              show: false,
            },
          },
        },
        name: props.name,
        mapType: props.name,
        type: 'map',
        aspectScale: 1,
        roam: false,
      },
    };
    return option;
  };

  const setOption = obj => {
    setMapOptions(props.getOption);
  };

  return mapaData.data ? (
    <React.Fragment>
      <TooltipMapa {...props.eventsProps} />
      <ReactEcharts
        echarts={echarts}
        ref={mapRef}
        option={getOption()}
        notMerge={false}
        lazyUpdate={false}
        style={{
          width: props.width,
          height: props.height,
          minHeight: props.minHeight ? props.minHeight : '',
        }}
        onEvents={onEvents}
        onChartReady={setOption}
      />
    </React.Fragment>
  ) : (
    <div />
  );
};

export default Mapa;
